import { getTelegramWebApp } from './telegram.js';
let lastHaptic = 0;
export function telegramHaptic() {
  try {
    const app = getTelegramWebApp();
    if (!app?.isVersionAtLeast?.('6.1') || localStorage.getItem('polka_haptics') === 'false' || Date.now() - lastHaptic < 100) return;
    app.HapticFeedback?.notificationOccurred('success');
    lastHaptic = Date.now();
  } catch { /* Device settings and unsupported clients may suppress haptics. */ }
}
export async function shareTelegramStory(path) {
  const app = getTelegramWebApp();
  if (!app?.isVersionAtLeast?.('7.8') || typeof app.shareToStory !== 'function') throw new Error('Обновите Telegram, чтобы поделиться историей');
  const { fetchWithAuth } = await import('../services/api.js');
  const story = await fetchWithAuth('/auth/telegram/share/story', { method: 'POST', body: JSON.stringify({ path }) });
  const options = { text: story.text };
  if (app.initDataUnsafe?.user?.is_premium) options.widget_link = { url: story.url, name: 'Открыть в Полке' };
  app.shareToStory(story.mediaUrl, options);
}
